const RECEIVING_LABELS_WAIT_MS = 15 * 60 * 1000;

let waitingUntil = 0;

export const expectReceivingLabels = () => {
  waitingUntil = Date.now() + RECEIVING_LABELS_WAIT_MS;
};

export const claimReceivingLabels = () => {
  const expected = Date.now() < waitingUntil;
  waitingUntil = 0;
  return expected;
};
